<template>
  <CFooter>
    <div class="ms-auto">
      <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 12 12"
        version="1.1">
        <g id="surface">
          <path style="
              stroke: none;
              fill-rule: nonzero;
              fill: rgb(60.78%, 13.33%, 14.9%);
              fill-opacity: 1;
            "
            d="M 9.949219 4.976562 C 9.949219 7.722656 7.722656 9.949219 4.976562 9.949219 C 2.226562 9.949219 0 7.722656 0 4.976562 C 0 2.226562 2.226562 0 4.976562 0 C 7.722656 0 9.949219 2.226562 9.949219 4.976562 Z M 9.949219 4.976562 " />
          <path style="stroke: none; fill-rule: nonzero; fill: rgb(100%, 100%, 100%); fill-opacity: 1"
            d="M 8.933594 4.976562 C 8.933594 7.160156 7.160156 8.933594 4.976562 8.933594 C 2.789062 8.933594 1.015625 7.160156 1.015625 4.976562 C 1.015625 2.789062 2.789062 1.015625 4.976562 1.015625 C 7.160156 1.015625 8.933594 2.789062 8.933594 4.976562 Z M 8.933594 4.976562 " />
          <path style="
              stroke: none;
              fill-rule: nonzero;
              fill: rgb(60.78%, 13.33%, 14.9%);
              fill-opacity: 1;
            "
            d="M 7.765625 4.976562 C 7.765625 6.515625 6.515625 7.765625 4.976562 7.765625 C 3.433594 7.765625 2.183594 6.515625 2.183594 4.976562 C 2.183594 3.433594 3.433594 2.183594 4.976562 2.183594 C 6.515625 2.183594 7.765625 3.433594 7.765625 4.976562 Z M 7.765625 4.976562 " />
          <path style="stroke: none; fill-rule: nonzero; fill: rgb(100%, 100%, 100%); fill-opacity: 1"
            d="M 6.496094 4.976562 C 6.496094 5.816406 5.816406 6.496094 4.976562 6.496094 C 4.132812 6.496094 3.453125 5.816406 3.453125 4.976562 C 3.453125 4.132812 4.132812 3.453125 4.976562 3.453125 C 5.816406 3.453125 6.496094 4.132812 6.496094 4.976562 Z M 6.496094 4.976562 " />
          <path style="stroke: none; fill-rule: nonzero; fill: rgb(100%, 100%, 100%); fill-opacity: 1"
            d="M 5.835938 4.316406 L 8.121094 4.316406 L 8.121094 5.582031 L 5.835938 5.582031 Z M 5.835938 4.316406 " />
        </g>
      </svg>
      <a class="me-1 app-footer-brand" target="_blank" href="https://www.ibs.srl/">
        <span class="ms-2">{{ new Date().getFullYear() }} IBS s.r.l.</span>
      </a>
    </div>
  </CFooter>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppFooter',
})
</script>

<style scoped>
.app-footer-brand {
  color: #9b2226;
  text-decoration: none;
  font-weight: bolder;
}
</style>
